import { makeStyles, Theme, createStyles } from "@material-ui/core";
export const useLoginStyles = makeStyles((theme: Theme) => {
	
	return createStyles({
		loginDrawerPaper: {
			width: "100vw",
			[theme.breakpoints.only("sm")]: {
				width: "60vw",
			},
			[theme.breakpoints.up("sm")]: {
				width: "50vw",
			},
			[theme.breakpoints.up("lg")]: {
				width: "30vw",
			},
		},
		wraper: {
			backgroundImage: `url(./login-register.jpg)`,
			height: "100vh",
		},
		formItem: {
			"&:not(:first-child)": {
				marginTop: theme.spacing(2),
			},
			width: "60%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
		textField: {
			width: "100%",
		},
		formContainer: {
			height: "100%",
		},
		localeSelection: {
			width: "60%",
			display: "flex",
			justifyContent: "flex-end",
			alignItems: "center",
		},
		alert: {
			position: "absolute",
			top: theme.spacing(2),
			width: "100%",
		},
	});
});
